import { Marker, type Map as MLMap } from 'maplibre-gl';
import type { LngLat } from '../shared/types';

/** 目的地のピン（ルートを選んでいる間と案内中に出す）。ルートを選んでいる間は指でずらせる */
export class DestinationPin {
  private readonly marker = new Marker({ color: '#e5484d' });
  private shown = false;
  private draggedAt = 0;

  constructor(private readonly map: MLMap) {
    this.marker.on('dragend', () => (this.draggedAt = Date.now()));
  }

  /** ドラッグを離した直後か（離したときのタップを「ピンをタップ」と取り違えないため） */
  get isDragging(): boolean {
    return Date.now() - this.draggedAt < 400;
  }

  onClick(cb: () => void): void {
    const el = this.marker.getElement();
    el.style.cursor = 'pointer';
    el.addEventListener('click', (e) => {
      e.stopPropagation(); // 地図のタップ（ポップアップを閉じる）にしない
      cb();
    });
  }

  set(position: LngLat | null): void {
    if (!position) {
      if (this.shown) this.marker.remove();
      this.shown = false;
      return;
    }
    this.marker.setLngLat(position);
    if (!this.shown) this.marker.addTo(this.map);
    this.shown = true;
  }

  setDraggable(on: boolean): void {
    this.marker.setDraggable(on);
    this.marker.getElement().classList.toggle('dest-draggable', on);
  }

  onDragEnd(cb: (p: LngLat) => void): void {
    this.marker.on('dragend', () => {
      const { lng, lat } = this.marker.getLngLat();
      cb([lng, lat]);
    });
  }
}
